/**
 * @param {ImageData} imageData RGBA
 * @returns {{ brightnessMean: number, sharpness: number, centroidOffsetRatio: number }}
 */
export function computeImageQualityScores(imageData) {
  const { width: w, height: h, data } = imageData;
  const gray = new Float32Array(w * h);
  let sum = 0;
  for (let i = 0, p = 0; i < data.length; i += 4, p++) {
    const y = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    gray[p] = y;
    sum += y;
  }
  const brightnessMean = sum / (gray.length * 255);

  let lapSumSq = 0;
  let lapN = 0;
  let weightedX = 0;
  let weightSum = 0;
  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      const p = y * w + x;
      const c = gray[p];
      const lap = 4 * c - gray[p - w] - gray[p + w] - gray[p - 1] - gray[p + 1];
      lapSumSq += lap * lap;
      lapN++;
      const wgt = Math.abs(lap) + 1;
      weightedX += x * wgt;
      weightSum += wgt;
    }
  }
  const sharpness = lapN > 0 ? lapSumSq / lapN : 0;
  const centroidX = weightSum > 0 ? weightedX / weightSum / w : 0.5;
  const centroidOffsetRatio = Math.abs(centroidX - 0.5);

  return { brightnessMean, sharpness, centroidOffsetRatio };
}
